import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EventSummaryCardComponent } from './event-summary-card.component';
import { EventPageModule } from 'src/app/pages/events/src/app/ui/event-page.module';
import { CurrencyExchangeConverterModule } from 'src/app/libs/common/pipes/currency-exhange-converter/currency-exhange-convertermodule';
import { I18nModule } from 'src/app/core/languages-support/i18n.module';
import { AppSupportedLanguages } from 'src/app/core/languages-support/i18n-config.service';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
    declarations: [EventSummaryCardComponent],
    exports: [
        EventSummaryCardComponent
    ],
    imports: [
        CommonModule,
        EventPageModule,
        I18nModule.forRoot(AppSupportedLanguages),
        CurrencyExchangeConverterModule,
        MatTooltipModule
    ]
})
export class EventSummaryCardModule { }
